import React from 'react';

import type {FileBrowserFile} from '../types';

type ImagePreviewProps = {
  file: FileBrowserFile;
};

export function ImagePreview({file}: ImagePreviewProps) {
  return (
    <div className="p-16 border-wb-border rounded-lg border">
      {file.url ? (
        <img alt={file.name} src={file.url} className="max-w-fit" />
      ) : (
        'No image preview available'
      )}
    </div>
  );
}
